module.exports = "<app-layout [data]=\"menu\">\n  <router-outlet></router-outlet>\n</app-layout>"